import {
  format,
  isSameYear,
  fromUnixTime,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from 'date-fns';

export default {
  methods: {
    messageStamp(time, dateFormat = 'h:mm a') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    messageTimestamp(time, dateFormat = 'MMM d, yyyy') {
      const messageTime = fromUnixTime(time);
      const now = new Date();
      const messageDate = format(messageTime, dateFormat);
      if (!isSameYear(messageTime, now)) {
        return format(messageTime, 'LLL d y, h:mm a');
      }
      return messageDate;
    },
    dynamicTime(time) {
      const unixTime = fromUnixTime(time);
      const now = new Date();

      const minutes = differenceInMinutes(now, unixTime);
      const hours = differenceInHours(now, unixTime);
      const days = differenceInDays(now, unixTime);
      const months = differenceInMonths(now, unixTime);
      const years = differenceInYears(now, unixTime);

      if (minutes < 1) {
        return this.$t('TIME_AGO.LESS_THAN_A_MINUTE');
      }
      if (minutes < 60) {
        return this.$tc('TIME_AGO.MINUTES_AGO', minutes, { count: minutes });
      }
      if (hours < 24) {
        return this.$tc('TIME_AGO.HOURS_AGO', hours, { count: hours });
      }
      if (days < 30) {
        return this.$tc('TIME_AGO.DAYS_AGO', days, { count: days });
      }
      if (months < 12) {
        return this.$tc('TIME_AGO.MONTHS_AGO', months, { count: months });
      }
      return this.$tc('TIME_AGO.YEARS_AGO', years, { count: years });
    },
    dateFormat(time, dateFormat = 'MMM d, yyyy') {
      const unixTime = fromUnixTime(time);
      return format(unixTime, dateFormat);
    },
    shortTimestamp(time, withAgo = false) {
      const unixTime = fromUnixTime(time);
      const now = new Date();

      const minutes = differenceInMinutes(now, unixTime);
      const hours = differenceInHours(now, unixTime);
      const days = differenceInDays(now, unixTime);
      const months = differenceInMonths(now, unixTime);
      const years = differenceInYears(now, unixTime);

      const ago = this.$t('TIME_AGO.SHORT_AGO');
      if (minutes < 1) return this.$t('TIME_AGO.SHORT_NOW');
      if (minutes < 60) return withAgo ? `${minutes}m ${ago}` : `${minutes}m`;
      if (hours < 24) return withAgo ? `${hours}h ${ago}` : `${hours}h`;
      if (days < 30) return withAgo ? `${days}d ${ago}` : `${days}d`;
      if (months < 12) return withAgo ? `${months}mo ${ago}` : `${months}mo`;
      return withAgo ? `${years}y ${ago}` : `${years}y`;
    },
  },
};
